export default "__VITE_PUBLIC_ASSET__6f7192ca__"